import logo from "./images/logo.svg"

export const Header = () => {
    return (
        <header className="site-header">
            <div className="container header-inner">
                <a className="brand" href="/">
                    <img id="logo-img" alt="" src={logo} />
                </a>
                <nav className="nav">
                    <div className="social">
                        <a
                            href="/goodies"
                        >
                            Goodies
                        </a>
                    </div>
                </nav>
            </div>
        </header>
    );
};
